// Turns the product film with the scroll; while pinned, lights the key figures one by one.
class QoProductHero extends HTMLElement {
  connectedCallback() {
    if (window.Shopify?.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.media = this.querySelector('.qo-ph__media');
    this.video = this.querySelector('.qo-ph__video');
    this.stats = [...this.querySelectorAll('.qo-stat')];
    this.wide = window.matchMedia('(min-width: 990px)');
    this.update = this.update.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.layout = this.layout.bind(this);

    this.dataset.reveal = 'armed';
    this.layout();
    this.wide.addEventListener('change', this.layout);
    this.prepareVideo();

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.dataset.reveal = 'in';
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      } else {
        window.removeEventListener('scroll', this.onScroll);
      }
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.wide?.removeEventListener('change', this.layout);
    window.removeEventListener('scroll', this.onScroll);
  }

  layout() {
    this.pinned = this.wide.matches && Number(this.dataset.run) > 0;
    this.classList.toggle('is-pinned', this.pinned);
    this.toggleAttribute('data-scrub', this.pinned && this.stats.length > 0);
    this.onScroll();
  }

  prepareVideo() {
    if (!this.video) return;
    this.video.addEventListener('seeked', () => {
      if (this.pending == null) return;
      const time = this.pending;
      this.pending = null;
      this.seek(time);
    });
    this.video.addEventListener('loadeddata', () => this.media.classList.add('is-ready'), { once: true });
    // iOS Safari only decodes frames for seeking after the video has played once.
    this.video.play().then(() => this.video.pause()).catch(() => {});
  }

  seek(time) {
    if (this.video.seeking) {
      this.pending = time;
      return;
    }
    if (Math.abs(this.video.currentTime - time) > 0.01) this.video.currentTime = time;
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    const rect = this.getBoundingClientRect();
    const viewport = window.innerHeight;
    const raw = this.pinned
      ? -rect.top / Math.max(rect.height - viewport, 1)
      : (viewport - rect.top) / (viewport + rect.height);
    const progress = Math.min(Math.max(raw, 0), 1);

    if (this.video?.duration) this.seek(progress * (this.video.duration - 0.05));
    if (this.pinned) {
      const steps = this.stats.length + 1;
      this.stats.forEach((stat, i) => stat.classList.toggle('is-on', progress >= (i + 1) / steps));
    }
  }
}

if (!customElements.get('qo-product-hero')) customElements.define('qo-product-hero', QoProductHero);
